import React from "react";
import { FiShield, FiLock, FiEye, FiFileText } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FFFBF7] font-sans text-slate-900">
      {/* Mini Nav */}
      <nav className="p-6 bg-white border-b border-orange-100 flex justify-between items-center">
        <button 
          onClick={() => navigate("/")}
          className="text-orange-500 font-bold flex items-center gap-2"
        >
          ← Back to Home
        </button>
        <span className="font-black text-slate-800">DIVYA INSTITUTE</span>
      </nav>

      <div className="max-w-4xl mx-auto py-16 px-8">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center text-white shadow-lg">
            <FiShield size={24} />
          </div>
          <h1 className="text-4xl font-black text-slate-900">Privacy Policy</h1>
        </div>

        <div className="bg-white rounded-[2rem] p-10 shadow-xl shadow-orange-100/50 space-y-8 text-slate-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-4 flex items-center gap-2">
              <FiEye className="text-orange-500" /> 1. Information We Collect
            </h2>
            <p>
              When you use our enrollment form, we collect personal information such as your 
              <strong> name, phone number, physical address, and course interests</strong>. 
              This is used solely to provide you with educational services and roadmaps.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-4 flex items-center gap-2">
              <FiLock className="text-orange-500" /> 2. How We Use Your Data
            </h2>
            <ul className="list-disc ml-6 space-y-2">
              <li>To process your course registration and student portal access.</li>
              <li>To contact you regarding class schedules, updates, and certifications.</li>
              <li>To improve our institute's curriculum based on student interests.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-4 flex items-center gap-2">
              <FiFileText className="text-orange-500" /> 3. Data Storage
            </h2>
            <p>
              Your data is securely stored using <strong>Supabase</strong> encryption standards. 
              We do not sell, trade, or rent your personal identification information to third parties.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mb-4">4. Your Rights</h2>
            <p>
              You have the right to request access to the data we hold about you or request its deletion 
              from our records at any time by contacting our Mardah Bazaar office.
            </p>
          </section>

          <div className="pt-8 border-t border-slate-100 text-sm italic">
            Last updated: April 2026
          </div>
        </div>
      </div>
    </div>
  );
}